import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-epg-provider',
  templateUrl: './epg-provider.component.html',
  styleUrls: ['./epg-provider.component.css']
})
export class EpgProviderComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
